"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixTable = void 0;
const react_1 = __importStar(require("react"));
const ag_grid_react_1 = require("ag-grid-react");
require("ag-grid-community/styles/ag-grid.css");
const matrix_view_model_components_1 = require("./matrix-view-model.components");
const partials_1 = require("../../cells/partials");
const constants_1 = require("../../constants");
const attribute_mapping_menu_component_1 = require("../context-menu/attribute-mapping-menu.component");
const matrix_context_menu_1 = require("../context-menu/matrix-context-menu");
const matrix_table_no_data_and_default_state_component_1 = require("./matrix-table-no-data-and-default-state.component");
const table_styles_1 = require("../table.styles");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const GRID_CONFIG = {
    rowModelType: 'clientSide',
    suppressContextMenu: true,
    suppressCellFocus: true,
    defaultColDef: { suppressMovable: true, resizable: false, sortable: false },
};
const MatrixTable = (_a) => {
    var { selectedAttributes = [] } = _a, props = __rest(_a, ["selectedAttributes"]);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const firstAttr = selectedAttributes[0];
    const gridRef = (0, react_1.useRef)(null);
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const [managedAttributeName, setManagedAttributeName] = (0, react_1.useState)(null);
    const vm = (0, matrix_view_model_components_1.useMatrixViewModel)({
        selectedAttribute: firstAttr,
        selectedStrategyNodeId: props.selectedStrategyNodeId,
        selectedCatalogId: props.selectedCatalogId,
        selectedProductTreeId: props.selectedProductTreeId,
        selectedL1Categories: props.selectedL1Categories,
        selectedDisplayTable: props.selectedDisplayTable,
        onManageAttribute: setManagedAttributeName,
    });
    const { contextMenu, open, close } = (0, matrix_context_menu_1.useMatrixContextMenu)();
    const refreshMappingCells = (0, react_1.useCallback)(() => {
        var _a;
        if ((_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api) {
            try {
                gridRef.current.api.refreshCells({
                    force: true,
                    suppressFlash: true, // Prevent flash animation for better UX
                });
            }
            catch (error) {
                console.error('Failed to refresh grid cells:', error);
            }
        }
    }, []);
    const renderGridContent = () => {
        if (!firstAttr) {
            return react_1.default.createElement(matrix_table_no_data_and_default_state_component_1.NoDataAndDefaultState, { errorMessage: vm.error, selectedAttribute: firstAttr });
        }
        if (vm.isLoading || props.categoriesIsLoading) {
            return react_1.default.createElement("div", null, t({ key: 'LOADING' }));
        }
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        react_1.default.createElement("div", { style: { position: 'relative' }, onContextMenu: (e) => e.preventDefault(), onClick: close }, react_1.default.createElement(table_styles_1.StyledGridContainer, null, react_1.default.createElement(ag_grid_react_1.AgGridReact, Object.assign(Object.assign({ ref: gridRef }, GRID_CONFIG), { columnDefs: vm.columnDefs, rowData: vm.rowData, colResizeDefault: "shift", pinnedBottomRowData: vm.pinnedBottomRowData, suppressFocusAfterRefresh: true, onCellContextMenu: (p) => {
                if (p.colDef.field === constants_1.TOTAL_PRODUCT_COUNT_FIELD || p.node.rowPinned)
                    return;
                open(p, vm.flattenedDataMap, vm.displayedProductTitles);
            } }))), (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.show) && (react_1.default.createElement(attribute_mapping_menu_component_1.AttributeMappingMenu, { x: contextMenu.x, y: contextMenu.y, isMapped: contextMenu.isMapped, title: contextMenu.title, value: contextMenu.value, colId: contextMenu.colId, cellType: contextMenu.cellType, selectedStrategyNodeId: props.selectedStrategyNodeId, selectedAttributeName: selectedAttributes[0], displayedProductTitles: vm.displayedProductTitles, onClose: close, onMappingChange: (key, isMapped) => {
                vm.handleMappingChange(key, isMapped);
                // Optimized grid refresh with error handling
                refreshMappingCells();
            } }))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, renderGridContent(), managedAttributeName && (react_1.default.createElement(partials_1.EditGuidelineDialog, { selectedAttribute: managedAttributeName, selectedStrategyNodeId: productTreeRootNodeId, onClose: () => setManagedAttributeName(null) }))));
};
exports.MatrixTable = MatrixTable;
exports.default = exports.MatrixTable;
